// Plaid bank feeds API. The server never returns access tokens.
import apiClient from '../../shared/services/apiClient';

export const bankFeedsAPI = {
  status: () => apiClient.get('/plaid/status'),
  linkToken: (data) => apiClient.post('/plaid/link-token', data),
  exchange: (data) => apiClient.post('/plaid/exchange', data),
  // businessId (optional): the selected business; the server narrows to it.
  items: (businessId) => apiClient.get('/plaid/items', { params: businessId ? { business_id: businessId } : {} }),
  suggestions: (itemId, businessId) => apiClient.get(`/plaid/items/${itemId}/suggestions`, { params: businessId ? { business_id: businessId } : {} }),
  mapAccount: (id, data) => apiClient.put(`/plaid/accounts/${id}`, data),
  sync: (itemId) => apiClient.post(`/plaid/items/${itemId}/sync`, {}),
  refreshFromBank: (itemId) => apiClient.post(`/plaid/items/${itemId}/refresh`, {}),
  syncDue: () => apiClient.post('/plaid/sync-due', {}),
  addBankFeeds: (businessId) => apiClient.post('/billing/bank-feeds-addon', { business_id: businessId }),
  entitlement: (businessId) => apiClient.get('/plaid/entitlement', { params: { business_id: businessId } }),
  balances: (itemId) => apiClient.post(`/plaid/items/${itemId}/balances`, {}),
  reauthComplete: (itemId) => apiClient.post(`/plaid/items/${itemId}/reauth-complete`, {}),
  startingBalanceReview: () => apiClient.get('/plaid/starting-balance-review'),
  startingBalance: (id) => apiClient.get(`/plaid/accounts/${id}/starting-balance`),
  setStartingBalance: (id) => apiClient.post(`/plaid/accounts/${id}/starting-balance`, {}),
  moveStartPreview: (id) => apiClient.get(`/plaid/accounts/${id}/move-start-to-bank`),
  moveStart: (id, data) => apiClient.post(`/plaid/accounts/${id}/move-start-to-bank`, { ...data, confirm: true }),
  // itemId: one bank connection ('none': accounts without a bank feed). The
  // answer carries per-bank counts and the total, so a capped list says so.
  matchReview: (status = 'open', itemId = null) => apiClient.get('/plaid/match-review', { params: { status, summary: 1, ...(itemId ? { item_id: itemId } : {}) } }),
  resolveMatch: (id, data) => apiClient.post(`/plaid/match-review/${id}/resolve`, data),
  duplicateReport: (accountId) => apiClient.get('/plaid/duplicate-report', { params: accountId ? { account_id: accountId } : {} }),
  remove: (itemId) => apiClient.delete(`/plaid/items/${itemId}`),
};
